import React, { Fragment } from "react";
import { IconChevronDown, IconChevronUp, IconDotsVertical } from "@tabler/icons-react";
import { AppConstant, LangConstant } from "const";
import { useTranslation } from "react-i18next";
import { Pagination } from "components";
import DepartmentListTable from "./DepartmentListTable";

const UnitListTable = ({
  unitList,
  totalPage,
  page,
  departmentList,
  onToggleShowDepartment,
  onChangePage,
  onOpenAction,
}) => {
  const { t: getLabel } = useTranslation();

  const langObj = getLabel(LangConstant.OBJ_UNIT_LIST_TABLE, { returnObjects: true });

  const handleClickAction = (event, row, type) => {
    onOpenAction(event, row, type);
  };

  return (
    <div>
      <div>
        <table className="table table-vcenter table-bordered" style={{ whiteSpace: "nowrap", tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}></th>
              <th style={{ width: "40%", fontWeight: "bold" }}>{langObj.name}</th>
              <th style={{ width: "25%", fontWeight: "bold" }}>{langObj.departmentNumber}</th>
              <th style={{ width: "25%", fontWeight: "bold" }}>{langObj.employeeNumber}</th>
              <th style={{ width: "5%" }}></th>
            </tr>
          </thead>
          <tbody>
            {unitList && unitList.length > 0 ? (
              unitList.map((row, index) => (
                <Fragment key={index}>
                  <tr>
                    <td>
                      <button
                        className="btn btn-icon btn-ghost-secondary btn-sm"
                        onClick={() => onToggleShowDepartment(row.unitId)}
                      >
                        {Object.keys(departmentList).includes(row.unitId) ? (
                          <IconChevronUp size={16} />
                        ) : (
                          <IconChevronDown size={16} />
                        )}
                      </button>
                    </td>
                    <td
                      title={row.unitName}
                      style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                      {row.unitName}
                    </td>
                    <td>{row.departmentNumber}</td>
                    <td>{row.employeeNumber}</td>
                    <td>
                      <button
                        className="btn btn-icon btn-ghost-secondary btn-sm"
                        onClick={event => handleClickAction(event, row, AppConstant.COMPANY_MANAGEMENT_TYPE.unit)}
                      >
                        <IconDotsVertical size={16} />
                      </button>
                    </td>
                  </tr>
                  {Object.keys(departmentList).includes(row.unitId) && (
                    <DepartmentListTable
                      departmentList={departmentList[row.unitId]}
                      onOpenAction={handleClickAction}
                      classes={{ name: "text-truncate" }}
                    />
                  )}
                </Fragment>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  <small>
                    <i>{getLabel(LangConstant.TXT_NOT_FOUND)}</i>
                  </small>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination currentPage={page} totalPages={totalPage} onPageChange={onChangePage} />
    </div>
  );
};

export default UnitListTable;
